import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton
} from 'react-admin';

// own ui
import CustomFilterText from '../../ui/custom-filter-text';
import CustomImageField from '../../ui/custom-image-field';
import ImageExporter from '../../exporter/image-exporter';

const ImageList = (props) => (
    <List
      title="Imagens" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterText /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ ImageExporter } >
        <Datagrid>
          <TextField source="id" sortable={true} />
          <CustomImageField source="url" label="Imagem" sortable={false}/>
          <TextField source="name" label="Nome" sortable={false} />
          <TextField source="label" label="Legenda" sortable={false} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
          <EditButton />
        </Datagrid>
    </List>
);

export default ImageList;
